import React from 'react';
import {formatNumber} from 'helpers/utils'
import PropTypes from 'prop-types';

const NumberRenderer = (props) => {
  const value = props.value !== 0 ? formatNumber(props.value) : null;

  return (
    <span className={`tw-text-right ${value < 0 ? 'tw-text-red-600' : 'tw-text-blue-600'}`}>{value}</span>
  );
};

NumberRenderer.propTypes = {
  value: PropTypes.number
};


export default NumberRenderer;
